import type {
  LinksFunction,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { loadJaneGoldRoute } from '@jane/bloom/loaders/routes/janeGold.server';
import { janeGoldRouteMeta } from '@jane/bloom/resources/meta/routes/janeGold';
import { plpStylesLinks } from '@jane/bloom/resources/plpStylesLinks';
import { ddTrace } from '@jane/bloom/services/dd-trace.server';
import type { RouteHandle } from '@jane/bloom/types/schemas/bloom/routeHandle';

export const handle: RouteHandle = {
  hydrate: true,
};

export const links: LinksFunction = () => [...plpStylesLinks];

export const meta: MetaFunction<typeof loader> = (args) => {
  return janeGoldRouteMeta(args);
};

export { productGridShouldRevalidate as shouldRevalidate } from '@jane/bloom/utils/routes/shouldRevalidate';

export const loader = async (args: LoaderFunctionArgs) =>
  ddTrace.initOnce().trace(
    'loader.$basename.jane-gold',
    {
      measured: true,
    },
    async () => {
      return await loadJaneGoldRoute({ args });
    }
  );

export { JaneGoldRouteComponent as default } from '@jane/bloom/components/routes/janeGold/janeGoldRouteComponent';
